export default {
  alerts: null,
  alertError: null,
  systemStatus: null,
  systemStatusError: null,
  cmsVersionMask: '##.##.##.###',
  recipientTypes: {
    notSet: 0,
    specificAgencies: 1,
    allAgencies: 2,
    region: 3
  },
  categories: { 0: 'Not Set', 1: 'System Outage', 2: 'Maintenance' },
  priorities: { 0: 'Not Set', 1: 'Low', 2: 'Medium', 3: 'High' },
  features: { 0: 'Not Set', 1: 'General', 2: 'Vendor', 3: 'Texting' },
  statusGroupDateFormat: { year: 'numeric', month: 'long', day: 'numeric' }
};
